import { lazy } from "react";
import { RoutesLink } from "@/utility/RouteLinks";
import { permissionKeys } from "@/utility/helper";
import type { IPrivateRoutes } from "../types";

// Leave
const AddLeave = lazy(() => import("@/pages/HRMS/Leave/AddLeave"));
const LeaveDetail = lazy(() => import("@/pages/HRMS/Leave/LeaveDetail"));
const TeamLeave = lazy(() => import("@/pages/HRMS/Leave/TeamLeave"));
const MyLeave = lazy(() => import("@/pages/HRMS/Leave/MyLeave"));

// Attendance
const MyAttendance = lazy(() => import("@/pages/HRMS/Attendance/MyAttendance"));
const AttendanceLog = lazy(() => import("@/pages/HRMS/Attendance/AttendaceLog"));
const DailyTeamAttendance = lazy(() => import("@/pages/HRMS/Attendance/DailyTeamAttendance"));
const MonthlyTeamAttendance = lazy(() => import("@/pages/HRMS/Attendance/MonthlyTeamAttendance"));
const MonthlySalaryPreview = lazy(() => import("@/pages/HRMS/Attendance/MonthlySalaryPreview/index"));
const ManageMonthlyBulkAttendance = lazy(() => import("@/pages/HRMS/Attendance/ManageMonthlyBulkAttendance"));

// WFH
const WFHRequest = lazy(() => import("@/pages/HRMS/WFH/WFHRequest"));
const WFHTeam = lazy(() => import("@/pages/HRMS/WFH/WFHTeam"));
const ADDWFH = lazy(() => import("@/pages/HRMS/WFH/ADDWFH"));
const WfhDetail = lazy(() => import("@/pages/HRMS/WFH/WfhDetail"));

// OD
const MyOd = lazy(() => import("@/pages/HRMS/Od/MyOd"));
const TeamOd = lazy(() => import("@/pages/HRMS/Od/TeamOd"));
const CreateOd = lazy(() => import("@/pages/HRMS/Od/CreateOd"));
const OdDetail = lazy(() => import("@/pages/HRMS/Od/OdDetail"));

// Regularization
const MyRegularization = lazy(() => import("@/pages/HRMS/Regularization/MyRegularization"));
const TeamRegularization = lazy(() => import("@/pages/HRMS/Regularization/TeamRegularization"));
const CreateRegularization = lazy(() => import("@/pages/HRMS/Regularization/CreateRegularization"));
const RegularizationDetails = lazy(() => import("@/pages/HRMS/Regularization/RegularizationDetails"));

export const attendanceRoutes: IPrivateRoutes[] = [
    // Leave
    {
        path: RoutesLink.addLeave,
        route: <AddLeave />,
        accessKey: permissionKeys.leave,
    },
    {
        path: `${RoutesLink.editLeave}/:id`,
        route: <AddLeave />,
        accessKey: permissionKeys.leave,
    },
    {
        path: `${RoutesLink.leaveDetail}/:id`,
        route: <LeaveDetail />,
        accessKey: permissionKeys.leave,
    },
    {
        path: `${RoutesLink.teamLeaveDetail}/:id`,
        route: <LeaveDetail />,
        accessKey: permissionKeys.leave,
        teamAccess: true,
    },
    {
        path: RoutesLink.teamLeave,
        route: <TeamLeave />,
        accessKey: permissionKeys.leave,
        teamAccess: true,
    },
    {
        path: RoutesLink.myLeave,
        route: <MyLeave />,
        accessKey: permissionKeys.leave,
    },

    // Attendance
    {
        path: RoutesLink.myAttendance,
        route: <MyAttendance />,
        accessKey: permissionKeys.attendance,
    },
    {
        path: `${RoutesLink.monthlyTeamAttendanceSummary}/:id`,
        route: <MyAttendance />,
        accessKey: permissionKeys.attendance,
    },
    {
        path: RoutesLink.attendanceLog,
        route: <AttendanceLog />,
        accessKey: permissionKeys.attendance,
    },
    {
        path: RoutesLink?.dailyTeamAttendance,
        route: <DailyTeamAttendance />,
        accessKey: permissionKeys.attendance,
    },
    {
        path: RoutesLink?.monthlyTeamAttendance,
        route: <MonthlyTeamAttendance />,
        accessKey: permissionKeys.attendance,
    },
    {
        path: RoutesLink?.monthlySalaryPreview,
        route: <MonthlySalaryPreview />,
        accessKey: permissionKeys.attendance,
    },
    {
        path: RoutesLink?.manageMonthlyBulkAttendance,
        route: <ManageMonthlyBulkAttendance />,
        accessKey: permissionKeys.attendance,
    },

    // WFH
    {
        path: RoutesLink.wfhRequest,
        route: <WFHRequest />,
        accessKey: permissionKeys.wfh,
    },
    {
        path: RoutesLink.teamWfh,
        route: <WFHTeam />,
        accessKey: permissionKeys.wfh,
        teamAccess: true,
    },
    {
        path: RoutesLink.addWfh,
        route: <ADDWFH />,
        accessKey: permissionKeys.wfh,
    },
    {
        path: `${RoutesLink.editWfh}/:id`,
        route: <ADDWFH />,
        accessKey: permissionKeys.wfh,
    },
    {
        path: `${RoutesLink.wfhDetail}/:id`,
        route: <WfhDetail />,
        accessKey: permissionKeys.wfh,
    },
    {
        path: `${RoutesLink.teamWfhDetail}/:id`,
        route: <WfhDetail />,
        accessKey: permissionKeys.wfh,
        teamAccess: true,
    },

    // OD
    {
        path: RoutesLink.myOd,
        route: <MyOd />,
        accessKey: permissionKeys.od,
    },
    {
        path: RoutesLink.teamOd,
        route: <TeamOd />,
        accessKey: permissionKeys.od,
        teamAccess: true,
    },
    {
        path: RoutesLink.createOd,
        route: <CreateOd />,
        accessKey: permissionKeys.od,
    },
    {
        path: `${RoutesLink.editOd}/:id`,
        route: <CreateOd />,
        accessKey: permissionKeys.od,
    },
    {
        path: `${RoutesLink.teamOdDetail}/:id`,
        route: <OdDetail />,
        accessKey: permissionKeys.od,
        teamAccess: true,
    },
    {
        path: `${RoutesLink.odDetail}/:id`,
        route: <OdDetail />,
        accessKey: permissionKeys.od,
        teamAccess: true,
    },

    // Regularization
    {
        path: RoutesLink.myRegularization,
        route: <MyRegularization />,
        accessKey: permissionKeys.regularization,
    },
    {
        path: RoutesLink.teamRegularization,
        route: <TeamRegularization />,
        accessKey: permissionKeys.regularization,
        teamAccess: true,
    },
    {
        path: RoutesLink.createRegularization,
        route: <CreateRegularization />,
        accessKey: permissionKeys.regularization,
    },
    {
        path: `${RoutesLink.editRegularization}/:id`,
        route: <CreateRegularization />,
        accessKey: permissionKeys.regularization,
    },
    {
        path: `${RoutesLink.regularizationDetail}/:id`,
        route: <RegularizationDetails />,
        accessKey: permissionKeys.regularization,
    },
    {
        path: `${RoutesLink.teamsRegularizationDetail}/:id`,
        route: <RegularizationDetails />,
        accessKey: permissionKeys.regularization,
        teamAccess: true,
    },
];
